<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 300px;">

        <el-form :model="editForm" :rules="rules" ref="editForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="时间" >
                <el-date-picker
                    v-model="editForm.time"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    disabled
                    :picker-options="pickerOption"
                    style="width:100%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="残疾人">
                <el-input v-model="editForm.elderlyName" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="isRemarks()">
            <el-col :span="24" class="item">
              <el-form-item label="备注">
                <el-input v-model="editForm.remarks" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24" class="item">
              <el-card class="box-card" shadow='never'>
                <div slot="header" class="clearfix">
                  <span>{{schedulName1}}</span>
                </div>
                <el-col :span="24" class="item">
                  <el-form-item label="用药组" >
                    <el-select
                        v-model="editForm.groupCodeArr1"
                        multiple
                        style="width:100%"
                        filterable
                        placeholder="请选择用药组">
                      <el-option
                          v-for="item in listGroup"
                          :key="item.medicationGroupCode"
                          :label="item.name"
                          :value="item.medicationGroupCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

              </el-card>
            </el-col>
          </el-row>

          <el-row style="margin-top: 10px;">
            <el-col :span="24" class="item">
              <el-card class="box-card" shadow='never'>
                <div slot="header" class="clearfix">
                  <span>{{schedulName2}}</span>
                </div>
                <el-col :span="24" class="item">
                  <el-form-item label="用药组">
                    <el-select
                        v-model="editForm.groupCodeArr2"
                        multiple
                        style="width:100%"
                        filterable
                        placeholder="请选择用药组">
                      <el-option
                          v-for="item in listGroup"
                          :key="item.medicationGroupCode"
                          :label="item.name"
                          :value="item.medicationGroupCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

              </el-card>
            </el-col>
          </el-row>

          <el-row style="margin-top: 10px;">
            <el-col :span="24" class="item">
              <el-card class="box-card" shadow='never'>
                <div slot="header" class="clearfix">
                  <span>{{schedulName3}}</span>
                </div>
                <el-col :span="24" class="item">
                  <el-form-item label="用药组">
                    <el-select
                        v-model="editForm.groupCodeArr3"
                        multiple
                        style="width:100%"
                        filterable
                        placeholder="请选择用药组">
                      <el-option
                          v-for="item in listGroup"
                          :key="item.medicationGroupCode"
                          :label="item.name"
                          :value="item.medicationGroupCode">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

              </el-card>
            </el-col>
          </el-row>


        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
      </div>

    </div>
  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Add',
  props:['nurseList','nurseAideList'],
  data() {
    return {
      loading: false,


      schedulName1:'早晨用药',
      schedulName2:'中午用药',
      schedulName3:'晚上用药',

      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        elderlyCode:'',
        elderlyName:'',

        time:'',
        status:0,
        medicationSchedulingCode:'',


        groupCodeArr1:[],
        groupCodeArr2:[],
        groupCodeArr3:[],

        schedulingPlan:[],
        remarks:null
      },

      pickerOption: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },

      listGroup:[],

      rules:{
        groupCodeArr1:[{ required: true, message: '请选择用药组', trigger: 'blur' }],
        groupCodeArr2:[{ required: true, message: '请选择用药组', trigger: 'blur' }],
        groupCodeArr3:[{ required: true, message: '请选择用药组', trigger: 'blur' }],
      }

    }
  },

  methods: {
    init(row){
      this.loading = false;

      this.$refs.editForm.resetFields();

      this.editForm.time = row.time;
      this.editForm.medicationSchedulingCode = row.medicationSchedulingCode;
      this.editForm.elderlyCode = row.elderlyCode;
      this.editForm.elderlyName = row.elderlyName;

      var Morning=this.getNurseCode(row.medicationSchedulingMorningDTO.medicationSchedulingMorningItemList)
      this.editForm.groupCodeArr1=Morning.list1

      var Noon=this.getNurseCode(row.medicationSchedulingNoonDTO.medicationSchedulingNoonItemList)
      this.editForm.groupCodeArr2=Noon.list1

      var Night=this.getNurseCode(row.medicationSchedulingNightDTO.medicationSchedulingNightItemList)
      this.editForm.groupCodeArr3=Night.list1

      this.getGroupList();

    },
    isRemarks(){
      if(this.editForm.time){
        var time=timefilters(this.editForm.time).slice(0,10)
        var nowTime=timefilters(new Date()).slice(0,10)
        if(time==nowTime){
          return true
        }
      }
      return false
    },

    getNurseCode(array){
      var listAll={list1:[],list2:[]}
      for(var i in array){

        if(array[i].medicationGroupCode){
          listAll.list1.push(array[i].medicationGroupCode)
        }

      }
      return listAll
    },

    closeSelf() {
      this.$emit("closeEdit");
    },


    getGroupList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicationGroup/ListByElderly2",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          elderlyCode:this.editForm.elderlyCode,
        }
      }).then( (response)=> {

        if(response.data.error == 0){
          this.listGroup = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    confirm(editForm){
      this.$refs[editForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.editForm.schedulingPlan=[];
      this.editForm.schedulingPlan.push({groupCodeArr:this.editForm.groupCodeArr1})
      this.editForm.schedulingPlan.push({groupCodeArr:this.editForm.groupCodeArr2})
      this.editForm.schedulingPlan.push({groupCodeArr:this.editForm.groupCodeArr3})


      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicationScheduling/Edit",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )

    },


  }
}


</script>





<style lang="scss" scoped>

.modal-goodslist {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x:auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width:800px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }
    .modal-body /deep/ .el-card__body{
      padding: 20px 0;
    }
    .box-card{
      margin: 10px 0;
    }
    .dishesPlanAdd{
      float: right;transform: translate(0px, -9px);
    }
    .modal-body {
      position: relative;
      padding: 20px 0px;
      z-index: 99;
      height: 60vh;
      overflow-y: auto;
    }
    .modal-footer {
      border-top: 1px solid #eee;
      justify-content: flex-end;
      padding: 15px;
      display: flex;
    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left:16px;
  width:56px;
  height: 36px;
  border:none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color:transparent;
}



.row{
  padding: 10px 0px;
}
.item{
  padding: 0px 20px;
}
.label{
  padding: 5px 0px;
}


</style>
